(async function () {
    const PAGES = ["newsletter_iohsub", "newsletter_iohsub_03"];
    const NOT_SELLING_PLAN_PAGES = ["klaviyo_seo01", "LP-org-plain", "LP-org-choc", "manukaLP2", "lp_gaba", "lp-gaba-2507-a", "lp_gaba0410", "lp-icl-ice-2510-a", "lp-hc-2310-e"];  // 新しいSourceを追加
  
    const params = new URLSearchParams(document.location.search.substring(1));
    const source = params.get("source"); 
  
    async function add_to_card(formData) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async response => {
        console.log(await response.json());
        window.location.href = "/cart";
        // return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
    
    if (PAGES.includes(source)) {
      // ... (既存のコード)
    } else if (NOT_SELLING_PLAN_PAGES.includes(source)) {
      // SELLING PLANのない商品をカートに追加するロジック
      const el = document.querySelector('#MainContent')
      el.style.display = 'none'
      
      const id = params.get("variant")
  
      let formData = {
        attributes: {
          __source: source,
        },
        items: [
          {
            quantity: 1,
            id,
            properties: {
              __source: source
            }
          }
        ]
      }
      add_to_card(formData)
    }
  })();
  